import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { DefaultCollectContext } from '../..';

export const ModalCollectCreated = () => {
  const { Modal } = useModal();

  const { protocolCollectCreated, isPreCollect, hasCreatePickupWithInvoice } =
    useContext(DefaultCollectContext);

  const handleCloseModal = () => {
    window.location.reload();
  };

  return (
    <Modal width={480} preventClose>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16
        }}
      >
        <ModalTitle>ATENÇÃO</ModalTitle>

        {isPreCollect && !hasCreatePickupWithInvoice ? (
          <>
            <ModalText>Pedido de Pré-Coleta gerado com sucesso.</ModalText>
            <ModalText>Protocolo: {protocolCollectCreated}</ModalText>
            <ModalText style={{ color: '#d11d1d', fontWeight: 'bold' }}>
              Será enviado um e-mail com o detalhamento da sua solicitação e com
              as orientações para anexar o documento fiscal.
            </ModalText>
            <ModalText>
              Para anexar o documento fiscal acesse o link abaixo:
            </ModalText>
          </>
        ) : (
          <>
            <ModalText>Pedido de coleta gerado com sucesso.</ModalText>
            <ModalText>Protocolo: {protocolCollectCreated}</ModalText>
            <ModalText>
              Para impressão da etiqueta acesse o portal do cliente
              “Acompanhamento de coleta” no ícone de download, através do link
              abaixo:
            </ModalText>
          </>
        )}

        <ModalText>
          <Link
            to="/area-do-cliente/minha-conta/search-minhas-coletas"
            data-testid="openPrintTagLink"
          >
            Clique aqui
          </Link>
        </ModalText>

        <Button
          type="button"
          data-testid="okCollectCreatedModalButton"
          variant="contained"
          onClick={handleCloseModal}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};
